import { render, staticRenderFns } from "./BillingPackages.vue?vue&type=template&id=1c1702b9"
import script from "./BillingPackages.vue?vue&type=script&lang=ts"
export * from "./BillingPackages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports